/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */

import { debounce } from 'lodash';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getTrustTableData } from '../../../../../api/trust';
import { Loader, Pagination, Table } from '../../../../../common/components';
import { useSetLoading } from '../../../../../common/hooks/appearance';
import { usePagination } from '../../../../../common/hooks/data';
import * as handlers from '../../../../../utils/handlers';
import DownloadModal from '../../../../reports/downloadModal/downloadModal';
import ItemEmptyTile from '../../../../reports/item-empty-tile/item-empty-tile';
import Toolbar from '../../../../reports/toolbar/toolbar';
import ListOfContractsRow from './listOfContractsRow';

export default function ListOfContracts({
  header,
  showTable,
  setShowTable,
  disabled,
  title,
  subtitle,
  subSubTitle,
  toolTipText,
  selectedAgreementID,
}) {
  const filterData = useSelector((state) => state.filters.filters);
  const [arAdjustmentTableData, setArAdjustmentTableData] = useState([]);
  const { page, limit, setPage, setLimit } = usePagination();
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(false);
  const [applyFilters, setApplyFilters] = useState(false);
  const [slStartNumber, setSlStartNumber] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [initialRenderDone, setInitialRenderDone] = useState(false);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

  const toggleDownloadModal = () => {
    if (arAdjustmentTableData?.length) {
      setIsDownloadModalOpen(!isDownloadModalOpen);
    }
  };

  const onDownloadClick = (response) => {
    handlers.successHandler({
      message: {
        message: response.msg,
        title: 'Success',
      },
    });
  };

  useEffect(() => {
    if (initialRenderDone) {
      getUpdatedTableData('globalFilterChange');
    }
    setInitialRenderDone(true);
  }, [filterData]);

  useEffect(() => {
    setSlStartNumber(page * limit - limit);
    if (applyFilters) {
      getUpdatedTableData('pagination');
    }
  }, [page, limit]);
  const getUpdatedTableData = async (type = 'pagination', value = '') => {
    setLoading(true);
    setApplyFilters(false);
    let page2 = page;
    let limit2 = limit;
    if (type === 'search' || type === 'globalFilterChange') {
      page2 = 1;
      limit2 = 5;
    }
    const requestParams = {
      ...filterData,
      startDate: showTable.fromDate,
      endDate: showTable.toDate,
      contractType: showTable.contractType,
      page: page2,
      needType: showTable.needType,
      trustType: showTable.trustType,
      limit: limit2,
      timezone: moment.tz.guess(),
      ...((type === 'search' || searchText.length > 0) && {
        search: type === 'search' ? value : searchText,
      }),
    };
    try {
      const { data } = await getTrustTableData(requestParams);
      let response;
      if (type === 'search') {
        setPage(1);
        setLimit(5);
        response = await getTrustTableData(requestParams);
        setTotalCount(response?.data?.count);
      }
      const { result, count, totalCount } = data || {};
      setArAdjustmentTableData(result);
      setShowTable({
        ...showTable,
        tableData: result,
        isSearchResult: true,
        totalResults: totalCount,
      });
      setTotalCount(count || totalCount);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handlers.apiErrorHandler(error);
    }
  };
  const debounceApiCall = useCallback(
    debounce((val) => {
      getUpdatedTableData('search', val);
    }, 2000),
    [],
  );
  const onSerchInputChange = (event) => {
    const {
      target: { value },
    } = event;
    setSearchText(value.trim());
    debounceApiCall(value);
  };
  useEffect(() => {
    if (!showTable?.isSearchResult) {
      setArAdjustmentTableData(showTable?.tableData);
      setTotalCount(showTable?.totalResults);
      setPage(1);
      setLimit(5);
      setSearchText('');
    }
  }, [showTable?.tableData]);
  const LoaderComponent = () => {
    if (loading) {
      return <Loader />;
    }
    return <ItemEmptyTile />;
  };
  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);
  return (
    <>
      <div className="trustaccounts-toolbar">
        {showTable?.tableData ? (
          <Toolbar
            title={title}
            subTitle={subtitle || `As on Date: ${moment().format('MMM DD,YYYY')}`}
            subSubTitle={subSubTitle}
            toolTipText={toolTipText}
            setSearchText={setSearchText}
            searchText={searchText}
            isSearchable
            onSerchInputChange={onSerchInputChange}
            SearchInputPlaceholder="Search with Contract Number"
            isTableDataPresent={showTable.tableData?.length > 0}
            optionOneLabel={showTable.hasDownloadFunctionality ? 'Download List' : null}
            optionOneIcon={showTable.hasDownloadFunctionality ? 'FiDownload' : null}
            onOptionOneClick={toggleDownloadModal}
          />
        ) : null}
      </div>
      <div className="trustaccounts-section">
        {arAdjustmentTableData && arAdjustmentTableData?.length > 0 ? (
          <>
            <div className="trust-listOfContracts">
              <Table headers={header} bordered responsive className="trustaccounts-table">
                <tbody>
                  {arAdjustmentTableData.map((item, index) => (
                    <ListOfContractsRow
                      key={`${item.agreementId.toString()}${index.toString()}`}
                      rowData={item?.Agreement}
                      inProgressStatus={item?.inProgress}
                      contractType={showTable?.contractType}
                      trustStatus={item?.TrustStatus}
                      agreementId={item?.agreementId}
                      selectedAgreementID={selectedAgreementID}
                      setShowTable={setShowTable}
                      showTable={showTable}
                      id={slStartNumber + index + 1}
                      disabled={disabled}
                      getUpdatedTableData={getUpdatedTableData}
                    />
                  ))}
                </tbody>
              </Table>
              {loading && <Loader />}
            </div>
            <div className="pagination-araging-report">
              <Pagination
                totalResults={totalCount}
                page={page}
                limit={limit}
                setPage={(val) => {
                  setApplyFilters(true);
                  setPage(val);
                }}
                setLimit={(val) => {
                  setApplyFilters(true);
                  setLimit(val);
                }}
              />
            </div>
          </>
        ) : (
          <div className="loader-empty">
            <LoaderComponent />
          </div>
        )}
        <DownloadModal
          isOpen={isDownloadModalOpen}
          toggle={toggleDownloadModal}
          reportType={showTable?.contractType}
          onDownloadClick={onDownloadClick}
          urlParams={{
            startDate: showTable.fromDate,
            endDate: showTable.toDate,
            needType: showTable?.needType || 0,
            trustType: showTable?.trustType || 0,
            contractType: showTable?.contractType,
            ...(searchText && { opiOrName: searchText }),
          }}
          willReceiveReportFileInEmail
          module="Trust"
        />
      </div>
    </>
  );
}
